<template>
  <div class="reference-standards__top flex flex-col justify-center gap-1 flex-auto">
    <h4 class="text-center" v-if="title">{{ title }}</h4>
    <div class="small-card h-full" v-if="references">
      <ol class="reference-standards__list">
        <li v-for="reference in references" :key="reference.id">
          {{ reference.name }} ({{ reference.percentage }}%)
        </li>
      </ol>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ReferenceStandard } from '@/types/ReferenceStandard'

export interface Props {
  references: ReferenceStandard[] | null
  title: string
}

const props = withDefaults(defineProps<Props>(), {
  references: null,
  title: ''
})
</script>

<style scoped lang="scss">
.reference-standards {
  &__list {
    counter-reset: referenceCounter;
    padding-left: 1.75rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    li {
      counter-increment: referenceCounter;
      position: relative;
      font-size: 1rem;
      font-family: var(--y-font-family-condensed);
      line-height: 1.25rem;

      &::before {
        content: counter(referenceCounter);
        color: var(--primary-accent-color);
        background: var(--secondary-brand-color);
        width: 1.25rem;
        height: 1.25rem;
        font-family: var(--y-font-family-condensed);
        font-size: 1rem;
        line-height: 1.25rem;
        font-weight: var(--y-font-weight-bold);
        border-radius: 50%;
        text-align: center;
        position: absolute;
        left: -1.75rem;
        top: 0;
        bottom: 0;
      }
    }
  }
}
</style>
